module.exports = __webpack_public_path__ + "media/plteacher.97b5a352.mp4";